import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v2H3V3z"
}), 'MaximizeOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MaximizeOutlined.js
// module id = 4787
// module chunks = 2